import React from 'react';
import { createSwitchNavigator } from 'react-navigation';
import { ContactScreen } from 'fitbeat.react-native-components';
import { WebHelp } from '../Components/Layouts/HelpSidebarNavigation';
import { WrapWithBackLayout } from '../Components/Layouts/FullWidthBackLayout';
import { FaqIFrame } from '../Components/FAQScreenContainer';

const isMobile = window.innerWidth <= 550;

export const HelpNavigationConfig = {
  Legal: {
    screen: WebHelp,
    path: 'legal',
  },
  Faq: {
    screen: (props) => {
      props.navigation.navigate('FaqScreen');
      return <div>loading</div>;
    },
    path: 'faq',
  },
};

const helpSettingsConfig = {
  backRoute: 'Help',
};

const MobileWebHelpNavigationConfig = {
  Help: {
    screen: WebHelp,
    initialRouteName: 'Help',
  },
  Faq: {
    screen: WrapWithBackLayout({ ...helpSettingsConfig, title: 'FAQ' })(FaqIFrame),
    path: 'faq',
  },
  Contact: {
    screen: WrapWithBackLayout({ ...helpSettingsConfig, title: 'Contact Us' })(ContactScreen),
    path: 'Contact',
  },
};
export const HelpNavigator = isMobile
  ? createSwitchNavigator(MobileWebHelpNavigationConfig)
  : createSwitchNavigator(HelpNavigationConfig);
